export enum Actions {
	manage = 'manage',
	create = 'create',
	read = 'read',
	update = 'update',
	delete = 'delete',
}
